import { Text, Accordion, Center } from "@mantine/core";
import { useEffect, useState } from "react";
import variables from "../../styles/variables.module.scss";
import markdownit from "markdown-it";
import { purfifyHTML } from "@/services/services";
import parse from "html-react-parser";
import { useWindowSize } from "usehooks-ts";

export default function Faq(props) {
  const [domLoaded, setDomLoaded] = useState(false);

  useEffect(() => {
    setDomLoaded(true);
  }, []);

  let eleHTML = <></>;
  if (domLoaded) {
    switch (props.display) {
      case "type1":
        eleHTML = <FaqType1 options={props.options} />;
        break;
      default:
        break;
    }
  }

  return eleHTML;
}

function FaqType1({ options }) {
  const dataList = options.data;
  const md = markdownit();
  const isMobile = useWindowSize().width < 768;
  const isTablet = useWindowSize().width < 1000;

  const componentStyles = options.styles;

  const wrapperStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 32,
    padding: 48,
    paddingLeft: isMobile ? 24 : 48,
    paddingRight: isMobile ? 24 : 48,
    width: "100%",
  };
  const titleStyle = {
    fontSize: 48,
    fontWeight: 700,
    lineHeight: "66px",
    letterSpacing: 0,
    textAlign: "center",
    color: variables.primaryColor,
  };

  const accordianItemStyle = {
    paddingLeft: "inherit",
    paddingRight: "inherit",
    backgroundColor: "#fff",
    borderRadius: "8px",
    border: "1px solid #dee2e6",
  };

  const accordianControlStyle = {
    fontSize: "18px",
    fontWeight: "bold",
  };

  return (
    <div
      style={{
        ...wrapperStyle,
        ...(componentStyles || {}),
      }}
    >
      <Text
        style={{
          ...titleStyle,
          ...(componentStyles?.header || {}),
        }}
      >
        {options.title}
      </Text>
      <Center w={"100%"}>
        <Accordion variant="separated" radius="lg">
          {(dataList ?? []).map((data, index) => {
            return (
              <Accordion.Item
                key={index}
                value={data.question}
                style={{
                  ...accordianItemStyle,
                  ...(componentStyles?.accordian || {}),
                }}
              >
                <Accordion.Control>
                  <Text
                    style={{
                      ...accordianControlStyle,
                      ...(componentStyles?.accordian?.control || {}),
                    }}
                  >
                    {data.question}
                  </Text>
                </Accordion.Control>
                <Accordion.Panel>
                  <div style={componentStyles?.markdown}>
                    {parse(purfifyHTML(md.render(data.answer)))}
                  </div>
                </Accordion.Panel>
              </Accordion.Item>
            );
          })}
        </Accordion>
      </Center>
    </div>
  );
}
